import { type ReactNode } from 'react';
import { type GridApi } from '@ag-grid-community/core';
import { type ICSAgGridProps } from '../ICSAgGrid';
import { ICSGridActions } from './ICSGridActions';
import { ICSGridSearch } from './search/ICSGridSearch';
import { useDetailSearchTarget } from './ICSGridActionsContext';
import s from './grid-controls.module.scss';

type ICSGridControlsProps<TData> = Omit<
    Partial<ICSAgGridProps<TData>>,
    'api'
> & {
    api?: GridApi<TData>;
    searchParams?: URLSearchParams;
};

export function ICSGridControls<TData>(
    props: ICSGridControlsProps<TData>,
): ReactNode {
    const { hideSearch, filterSlot, searchPlaceholder } = props;
    const detailSearchTarget = useDetailSearchTarget();
    const searchProps = detailSearchTarget
        ? {
              ...props,
              api: detailSearchTarget.api as GridApi<TData>,
              columnDefs: detailSearchTarget.columnDefs,
          }
        : props;

    const search = hideSearch ? null : (
        <div className="w-full">
            <ICSGridSearch
                {...searchProps}
                searchPlaceholder={searchPlaceholder}
            />
        </div>
    );

    return (
        <div className={s.gridControls}>
            {filterSlot ? (
                <div className="flex align-items-end gap-2 w-full">
                    {filterSlot}
                    {search}
                </div>
            ) : (
                search
            )}
            <ICSGridActions {...props} />
        </div>
    );
}
